import { Adapter } from './adapter';

export class DebugAdapter extends Adapter {
  constructor({ logger }) {
    super({ logger: logger.withPrefix('debug') });
    this.log('adapter configured');
  }

  trackEvent(eventName, eventData) {
    this.logEvent(eventName, { eventName, eventData });
  }

  trackClick(event, eventName, eventData) {
    this.logEvent(event.type, { event, eventName, eventData });
  }

  trackFormSubmit(event, $form, onSubmitEventName, onSubmitEventData) {
    const convertedFieldData = this.convertDataToFieldData(onSubmitEventData, $form);
    this.logEvent(event.type, {
      event,
      $form,
      onSubmitEventName,
      onSubmitEventData,
      convertedFieldData,
    });
  }

  trackGFFormConfirmation(event, formId) {
    this.logEvent(event.type, { event, formId });
  }
}
